import React, {useContext, useEffect, useState} from "react";
import '../../resources/css/admin_style.css';
import styles from './Audit.module.css';
import {Box, Tab, Tabs} from "@mui/material";
import {a11yProps, TabPanel} from "../../utils/tab/TabPanel";
import {TableContext, TableStateType} from "../../utils/contextapi/TableProvider";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale/ko";
import {IAM_SERVER_AUDIT_ADMIN, IAM_SERVER_SERVICE, USER_SERVER_COMMON} from "../../utils/Config";
import axios from "../../utils/api/axios";
import Loading from "../../utils/loading/Loading";
import {AuditTokenContainer} from "./tab/AuditTokenContainer";
import {AuditContainer} from "./tab/AuditContainer";
import dayjs from "dayjs";
import { useServiceList } from "../../utils/service/serviceList";

/**
 * 로그관리 페이지
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function Audit({isMobile, setMovePage}) {

    const context = useContext(TableContext);

    const [loading, setLoading] = useState(true);
    const [tab, setTab] = React.useState(0);

    // 조회 Custom
    const getSearchModel = () => ({
        dateFrom: dayjs(context.state.dateRange[0]).format('YYYY-MM-DD'),
        dateTo: dayjs(context.state.dateRange[1]).format('YYYY-MM-DD'),
        searchKind: context.state.selectedMain?.toString() ?? "",
        searchKind1: context.state.selectedSub?.toString() ?? ""
    });

    // 그 다음에 state나 코드에서 사용
    const [searchModel, setSearchModel] = useState(getSearchModel());

    useEffect(() => {
        // setMovePage("audit");
        context.actions.contextDispatch({type: TableStateType.MAIN_CODE, data: ""});
        context.actions.contextDispatch({type: TableStateType.SUB_CODE, data: ""});
        context.actions.contextDispatch({type: TableStateType.SELECTED_MAIN, data: ""});
        context.actions.contextDispatch({type: TableStateType.SELECTED_SUB, data: ""});

        setSearchModel((prevState) => ({
            ...prevState,
            searchKind: "",
            searchKind1: "",
        }));
        initMainCode();
    }, [tab]);

    // mainCode가 1개가 되었을 때만 자동 선택(한번만)
    useEffect(() => {
        if (tab === 0 && Object.keys(context.state.mainCode).length === 1) {
            const onlyKey = Object.keys(context.state.mainCode)[0];
            context.actions.contextDispatch({type: TableStateType.SELECTED_MAIN, data: onlyKey});
            handleMainCode(onlyKey);
            setSearchModel((prevState) => ({
            ...prevState,
                searchKind: onlyKey,
                searchKind1: "",
            }));
        }
        // eslint-disable-next-line
    }, [context.state.mainCode, tab]);

    // 로그 탭 handler
    const handleChange = (event, value) => {
        setTab(value);
    };


    // 메인 검색 조건 조회 API
    const initMainCode = () => {
        setLoading(true);
        if (tab === 0) { // 알람 로그 탭
            const url = IAM_SERVER_AUDIT_ADMIN + "/tokenMainCode";
            axios.get(url)
                .then((res) => {
                    context.actions.contextDispatch({type: TableStateType.MAIN_CODE, data: res.data.data})
                })
                .finally(() => {
                    setLoading(false);
                })
        } else { // 관리자 로그 탭
            const url = IAM_SERVER_AUDIT_ADMIN + "/auditMainCode";
            axios.get(url)
                .then((res) => {
                    context.actions.contextDispatch({type: TableStateType.MAIN_CODE, data: res.data.data})
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    // 서브 검색 조건 조회 API
    const handleMainCode = (valueOrEvent) => {

        // valueOrEvent가 event 객체면 e.target.value 사용, 아니면 그대로 value로 사용
        const value = typeof valueOrEvent === "string" ? valueOrEvent : valueOrEvent.target.value;
        context.actions.contextDispatch({type: TableStateType.SELECTED_MAIN, data: value})
        context.actions.contextDispatch({type: TableStateType.SELECTED_SUB, data: ""})

        if (value === '') {
            context.actions.contextDispatch({type: TableStateType.SUB_CODE, data: ""})
        } else if (tab === 0) { // 알람 로그 탭
            const url = IAM_SERVER_AUDIT_ADMIN + "/auditSubCode/" + value;
            axios.get(url)
                .then((res) => {
                    context.actions.contextDispatch({type: TableStateType.SUB_CODE, data: res.data.data})
                })
                .catch(err => {
                console.error("서브 로그 불러오기 실패", err);
            });
        } else { // 관리자 로그 탭
            const url = IAM_SERVER_AUDIT_ADMIN + "/auditSubCode/" + value
            axios.get(url)
                .then((res) => {
                    context.actions.contextDispatch({type: TableStateType.SUB_CODE, data: res.data.data})
                })
                .catch(err => {
                console.error("서브 로그 불러오기 실패", err);
            });
        }
    }

    return (
        <div className={"rightCont__cont"}>
            <h2 className={styles.sectionTitle}>로그 관리</h2>
            <Box className={`${styles.rightCont__cont__situTop} ${styles.log}`}>
                <Box sx={{borderBottom: 1, borderColor: 'black'}}>
                    <Tabs className={styles.rightCont__cont__tabBtnWrap} value={tab} onChange={handleChange} indicatorColor={"none"}>
                        <Tab
                            className={`${styles.rightCont__cont__tabBtn} ${styles.alarm} ${tab === 0 ? styles.current : null}`}
                            label="토큰 로그" {...a11yProps(0)} />
                        <Tab
                            className={`${styles.rightCont__cont__tabBtn} ${styles.manage} ${tab === 1 ? styles.current : null}`}
                            label="운영 로그" {...a11yProps(1)} />
                    </Tabs>
                </Box>
            </Box>

            <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                { loading ? <Loading /> :
                    <>
                        <TabPanel value={tab} index={0}>
                            <AuditTokenContainer isMobile={isMobile}/>
                        </TabPanel>
                        <TabPanel value={tab} index={1}>
                            <AuditContainer isMobile={isMobile}/>
                        </TabPanel>
                    </>
                }
            </div>

        </div>
    )
}

export default Audit;